import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse, SubmitInsuranceRequest } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'
import { bookingSessionKeys } from './keys.js'

export const useSubmitInsurance = (
  sessionId: string,
  /**
   * `throwOnError` accepte aussi un prédicat, comme {@link useSubmitPassengers} :
   * l'étape Assurances ne renvoie à la boundary que les sessions expirées, et
   * garde les autres échecs en ligne pour ne pas perdre le choix d'assurance.
   */
  { throwOnError = false }: { throwOnError?: ((error: Error) => boolean) | boolean }
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SubmitInsuranceRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/insurance`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
      queryClient.setQueryData(bookingSessionKeys.insuranceEstimate(sessionId), data)
    },
    throwOnError,
  })
}
